"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateApiHeaders = exports.generateHmac = exports.generateHardwareFingerprint = exports.getCurrentTimestampInMilliseconds = void 0;
var crypto_1 = __importDefault(require("crypto"));
var getCurrentTimestampInMilliseconds = function () { return Math.floor(Date.now()).toString(); };
exports.getCurrentTimestampInMilliseconds = getCurrentTimestampInMilliseconds;
var generateHardwareFingerprint = function (fi) {
    var base = "vollJeheim".concat(fi);
    return crypto_1.default.createHash('sha256').update(base).digest('hex');
};
exports.generateHardwareFingerprint = generateHardwareFingerprint;
/**
 * generates hash signature for fe apis
 * @param tenant config tenant
 * @param timestamp grab timestamp in ms
 * @returns hash as hex
 */
var generateHmac = function (tenant, timestamp) {
    // create base: tenant + timestamp
    var xEcHmacBase = "".concat(tenant).concat(timestamp);
    // hash base
    return crypto_1.default.createHash('sha256').update(xEcHmacBase).digest('hex');
};
exports.generateHmac = generateHmac;
/**
 * fires all necessary functions for required headers
 * @param fi extracted property from token contents of session
 * @param tenant config tenant baurde etc
 * @returns object containing all required headers
 */
var generateApiHeaders = function (_a) {
    var fi = _a.fi, tenant = _a.tenant;
    var timestamp = (0, exports.getCurrentTimestampInMilliseconds)();
    var hmacHash = (0, exports.generateHmac)(tenant, timestamp);
    var hardwareFingerprint = (0, exports.generateHardwareFingerprint)(fi);
    return {
        'x-ec-timestamp': timestamp,
        'x-ec-hmac': hmacHash,
        'x-ec-hfi': hardwareFingerprint,
    };
};
exports.generateApiHeaders = generateApiHeaders;
//# sourceMappingURL=apiHeaders.js.map